export default "__VITE_ASSET__BPjORJ6w__"